import { useCallback, useEffect, useState } from 'react';
import { fetchRedeemableGames, fetchClosedGames } from '../supabase/redeemGamesApi';

/**
 * Hook to fetch and manage redeemable and closed games
 * 
 * @returns {object} - Games data, loading states, and refresh function
 */
export function useRedeemGames() {
  const [redeemableGames, setRedeemableGames] = useState([]);
  const [closedGames, setClosedGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadGames = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const [redeemableResult, closedResult] = await Promise.all([
        fetchRedeemableGames(),
        fetchClosedGames(),
      ]);

      if (redeemableResult.error) {
        throw new Error(redeemableResult.error);
      }

      if (closedResult.error) {
        throw new Error(closedResult.error);
      }

      setRedeemableGames(redeemableResult.games);
      setClosedGames(closedResult.games);
    } catch (err) {
      console.error('Error loading games:', err);
      setError(err.message || 'Failed to load games');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGames();
  }, [loadGames]);

  return {
    redeemableGames,
    closedGames,
    loading,
    error,
    refresh: loadGames,
  };
}
